import React, { useRef } from 'react';

import MInputView from './MInput.view';

type Props = {
  innerRef?: React.RefObject<HTMLInputElement>;
  name?: string;
  invalid?: boolean;
  valid?: boolean;
  disabled?: boolean;
  value?: string | number;
  type?: string;
  className?: string;
  min?: string;
  max?: string;
  step?: string;
  placeholder?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  autoSelectOnFocus?: boolean;
  defaultValue?: string;
  pattern?: string;
  required?: boolean;
  inputClassName?: string;
  startIcon?: JSX.Element | null;
  endIcon?: JSX.Element | null;
  bottomBorder?: boolean;
  ignoreInvalidIcon?: boolean;
  tabIndex?: number;
  validationErrorText?: string | null;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => string;
  onFocus?: () => void;
  onPaste?: (value: React.ClipboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const MInput: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const innerInputRef = useRef<HTMLInputElement>(null);
  const inputRef = props.innerRef || innerInputRef;

  return (
    <MInputView
      innerRef={inputRef}
      name={props.name}
      invalid={props.invalid}
      disabled={props.disabled}
      value={props.value}
      type={props.type}
      className={props.className}
      min={props.min}
      max={props.max}
      step={props.step}
      placeholder={props.placeholder}
      autoComplete={props.autoComplete || 'off'}
      autoFocus={props.autoFocus}
      autoSelectOnFocus={props.autoSelectOnFocus}
      defaultValue={props.defaultValue}
      pattern={props.pattern}
      inputClassName={props.inputClassName}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      bottomBorder={props.bottomBorder}
      ignoreInvalidIcon={props.ignoreInvalidIcon}
      tabIndex={props.tabIndex}
      validationErrorText={props.validationErrorText}
      onInput={props.onInput}
      onFocus={props.onFocus}
      onPaste={props.onPaste}
      onBlur={props.onBlur}
      onChange={props.onChange}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
    >
      {props.children}
    </MInputView>
  );
};

MInput.displayName = 'MInput';
MInput.defaultProps = {};

export default MInput;
